import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import '../remark-element';
import './app-navigator-menu';
import '../form/button';

// More on default export: https://storybook.js.org/docs/web-components/writing-stories/introduction#default-export
export default {
  title: '@gsmlg/app-navigator/menu',
  // More on argTypes: https://storybook.js.org/docs/web-components/api/argtypes
  argTypes: {},
} as Meta;

export interface ElementProps {
  appName: string;
  fixed: boolean;
  controlParent: boolean;
  color: string;
  backgroundColor: string;
}

// prettier-ignore
const Template: Story<ElementProps> = ({
  color,
  backgroundColor,
}) =>
  html`
  <app-navigator-menu
    color=${color}
    background-color=${backgroundColor}
  >
    <wc-button mode="link">Go To Github</wc-button>

    <wc-button href="https://github.com/gsmlg" target="_blank" slot="submenu">Youtube</wc-button>
    <wc-button href="https://github.com/gsmlg" target="_blank" slot="submenu">Twitter</wc-button>
    <wc-button href="https://github.com/gsmlg" target="_blank" slot="submenu">Facebook</wc-button>
    <wc-button href="https://github.com/gsmlg" target="_blank" slot="submenu">Instagram</wc-button>
  </app-navigator-menu>
  
  <remark-element>
    ## app-navigator-menu element

    Render AppNavigator Menu for application.

    \`\`\`html
    ${`<app-navigator-menu
    color=${color}
    background-color=${backgroundColor}
  >
    <wc-button href="https://github.com/gsmlg" target="_blank">Go To Github</wc-button>

    <wc-button href="https://github.com/gsmlg" target="_blank" slot="submenu">Youtube</wc-button>
    <wc-button href="https://github.com/gsmlg" target="_blank" slot="submenu">Twitter</wc-button>
    <wc-button href="https://github.com/gsmlg" target="_blank" slot="submenu">Facebook</wc-button>
    <wc-button href="https://github.com/gsmlg" target="_blank" slot="submenu">Instagram</wc-button>
  </app-navigator-menu>`}
    \`\`\`

    ### CSS Variables

    \`\`\`css
    var(--app-navigator-menu-background-color, #fc125c);
    var(--app-navigator-menu-color, #fff);
    \`\`\`

    ### attributes:

    - \`app-name\`

    show when screen width > 992px

  </remark-element>
  
  `;

export const Basic = Template.bind({});
// More on args: https://storybook.js.org/docs/web-components/writing-stories/args
Basic.args = {
  color: '#362424',
  backgroundColor: 'transparent',
};
